import {readAsArrayBuffer} from './asyncReader.js';
// import {getAsset} from './prepareAssets';
import {noop} from './helper.js';
import constants from "../../../../constants";
const { PDFDocument } = require('pdf-lib');

export async function save(pdfFile, objects, currentUserId, autoSignOptions) {
  //const download = await getAsset('download');
  let pdfDoc;
  try {
    var pdfFileRead = await readAsArrayBuffer(pdfFile)
    pdfDoc = await PDFDocument.load(pdfFileRead);
  } catch (e) {
    console.log('Failed to load PDF.');
    throw e;
  }
  const pagesProcesses = pdfDoc.getPages().map(async (page, pageIndex) => {
    //Add các thông tin phụ: ký bởi, ngày ký, số ký hiệu,...
    if (autoSignOptions) {
      // Register fontkit instance with PDFDocument
      // pdfDoc.registerFontkit(fontkit);

      // Fetch and embed the custom font
      const fontBytes = await fetch(constants.BE_VN_PRO_FONT).then(res => res.arrayBuffer())
      const customFont = await pdfDoc.embedFont(fontBytes)

      const heightFile = page.getHeight();
      page.drawText(autoSignOptions.valueDocCode, {
          x: 28,
          y: heightFile - 30,
          size: 9,
        }
      );
      page.drawText(autoSignOptions.valueDocDate, {
          x: 28,
          y: heightFile - 41,
          size: 9,
          font: customFont,
        }
      );
      page.drawText(autoSignOptions.valueSignBy, {
          x: 400,
          y: heightFile - 30,
          size: 9,
          font: customFont,
        }
      );
      page.drawText(`Ngày ký: ${autoSignOptions.valueSignDate}`, {
          x: 400,
          y: heightFile - 41,
          size: 9,
          font: customFont,
        }
      );
    }
    //Add danh sách chữ ký
    let pageObjects = [];
    for (let i = 0; i < objects.length; i++){
      const object = objects[i];
      if (object.pageIndex === pageIndex && object.userId === currentUserId){
        pageObjects.push(object);
      }
    }
    const embedProcesses = pageObjects.map(async (object) => {
      let positionX = object.positionX;
      let positionY = object.positionY;
      let imgData = object.imgData;
      let positionW = object.positionW;
      let positionH = object.positionH;
      let pageSizeHeight = object.pageSizeHeight
      let pageSizeWidth = object.pageSizeWidth
      let img;
      let imgObj = await fetch(imgData);
      let imageBlob = await imgObj.blob();
      try {
        img = await pdfDoc.embedPng(await readAsArrayBuffer(imageBlob));
        return () =>{
          page.drawImage(img, {
            x: ((page.getWidth() * positionX)/pageSizeWidth),
            y: page.getHeight() - ((page.getHeight() * positionY) / pageSizeHeight) - positionH + 20,
            width: positionW - 20,
            height: positionH - 20,
          });
        }
      } catch (e) {
        console.log('Failed to embed image.', e);
        return noop;
      }
    });
    const drawProcesses = await Promise.all(embedProcesses);
    drawProcesses.forEach((p) => p());
  });
  await Promise.all(pagesProcesses);
  try {
    //download(pdfBytes, name, 'application/pdf');
    return await pdfDoc.save();
  } catch (e) {
    console.log('Failed to save PDF.');
    throw e;
  }


}



// WEBPACK FOOTER //
// ./src/views/doc-out/components/pdf-lib-utils/SignPdfKyDongTrinh.js